import AssetSingleCreateTab from "./AssetSingleCreateTab";

export default AssetSingleCreateTab;
